import { Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { PermissionUtils } from 'utils'
import {
  EndUserDeclarationLayer,
  MarketingModeLayer,
} from 'modules/simulatorTrainings/common/layers'
import SimulatorTrainingInstructorILSchedulesRouting, {
  routes as simulatorTrainingInstructorILSchedulesRoutes,
} from 'modules/simulatorTrainings/instructor/instructorLed/Schedules/routing'
import SimulatorTrainingInstructorILSimulatorListRouting, {
  routes as simulatorTrainingInstructorILSimulatorListRoutes,
} from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/routing'
import SimulatorTrainingInstructorILSimulatorSheetRouting, {
  routes as simulatorTrainingInstructorILSimulatorSheetRoutes,
} from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorSheet/routing'
import SimulatorTrainingInstructorILTrainingDetailsRouting, {
  routes as simulatorTrainingInstructorILTrainingDetailsRoutes,
} from 'modules/simulatorTrainings/instructor/instructorLed/TrainingDetails/routing'
import SimulatorTrainingInstructorSLExerciseListRouting, {
  routes as simulatorTrainingInstructorSLExerciseListRoutes,
} from 'modules/simulatorTrainings/instructor/studentLed/ExerciseList/routing'
import SimulatorTrainingInstructorSLExerciseSheetRouting, {
  routes as simulatorTrainingInstructorSLExerciseSheetRoutes,
} from 'modules/simulatorTrainings/instructor/studentLed/ExerciseSheet/routing'
import SimulatorTrainingInstructorSLSchedulesRouting, {
  routes as simulatorTrainingInstructorSLSchedulesRoutes,
} from 'modules/simulatorTrainings/instructor/studentLed/Schedules/routing'
import SimulatorTrainingInstructorSLTrainingDetailsRouting, {
  routes as simulatorTrainingInstructorSLTrainingDetailsRoutes,
} from 'modules/simulatorTrainings/instructor/studentLed/TrainingDetails/routing'
import routes from './routes'

const { RouteChangeProgress } = common

const SimulatorTrainingInstructorRouting = () => {
  const simulatorTrainingInstructorLedDenied =
    PermissionUtils.simulatorTrainingInstructorLedDenied()
  const simulatorTrainingStudentLedDenied = PermissionUtils.simulatorTrainingStudentLedDenied()
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <MarketingModeLayer>
        <EndUserDeclarationLayer>
          <Switch>
            <PrivateRoute
              path={simulatorTrainingInstructorILSchedulesRoutes.root}
              component={SimulatorTrainingInstructorILSchedulesRouting}
              disabled={simulatorTrainingInstructorLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorILSimulatorListRoutes.root}
              component={SimulatorTrainingInstructorILSimulatorListRouting}
              disabled={simulatorTrainingInstructorLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorILSimulatorSheetRoutes.root}
              component={SimulatorTrainingInstructorILSimulatorSheetRouting}
              disabled={simulatorTrainingInstructorLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorILTrainingDetailsRoutes.root}
              component={SimulatorTrainingInstructorILTrainingDetailsRouting}
              disabled={simulatorTrainingInstructorLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorSLExerciseListRoutes.root}
              component={SimulatorTrainingInstructorSLExerciseListRouting}
              disabled={simulatorTrainingStudentLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorSLTrainingDetailsRoutes.root}
              component={SimulatorTrainingInstructorSLTrainingDetailsRouting}
              disabled={simulatorTrainingStudentLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorSLSchedulesRoutes.root}
              component={SimulatorTrainingInstructorSLSchedulesRouting}
              disabled={simulatorTrainingStudentLedDenied}
            />
            <PrivateRoute
              path={simulatorTrainingInstructorSLExerciseSheetRoutes.root}
              component={SimulatorTrainingInstructorSLExerciseSheetRouting}
              disabled={simulatorTrainingStudentLedDenied}
            />
            <Redirect path='*' to={routes.root} />
          </Switch>
        </EndUserDeclarationLayer>
      </MarketingModeLayer>
    </Suspense>
  )
}

export default SimulatorTrainingInstructorRouting
